<template>
  <div>
    <el-button type="primary" :size="btnSize" @click="chgHandle" icon="edit">
      <slot></slot>
    </el-button>
    <Modal v-model="modalShow" width="400" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>修改会员有效期</span>
      </p>
      <el-form :inline="true" label-width="90px">
        <el-form-item label="有效期:">
          <DatePicker
            v-model="expireDate"
            :options="endOptions"
            type="date"
            :placeholder="expireShow"
            format="yyyy-MM-dd"
            placement="bottom-end"
          ></DatePicker>
        </el-form-item>
        <br />
        <el-form-item label="操作类型:">
          <!-- style="border: 1px solid #dcdee2;" -->
          <el-select v-model="selectValue" placeholder="请选择操作类型">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 110px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
import { formatDateString } from "../commonEdu";
export default {
  name: "stuChgExpire",
  components: {},
  data() {
    return {
      modalShow: false,
      // expireDate: "",
      endOptions: {
        shortcuts: [
          {
            text: "永久有效",
            value() {
              return "2121-01-01";
              // return "";
            },
          },
        ],
      },
      expireShow: "请选择有效期",
      // 下拉框
      options: [
        {
          value: "1",
          label: "续费",
        },
        {
          value: "2",
          label: "退费",
        },
      ],
      selectValue: "",
      expireDate: "",
      // signupDate:''//报名时间
    };
  },
  props: {
    len: {
      type: Number,
      default: 1,
    },
    btnSize: {
      type: String,
      default: "normal",
    },
    expireDate1: {
      type: String,
      default: "",
    },
    expireTag: {
      type: String,
      default: "",
    },
    signupDate: {
      type: String,
      default: "",
    },
    bmTime: {
      type: String,
      default: "",
    },
  },
  created() {
  },
  watch: {
    expireDate1(val, oldVal) {
      if (val) {
        this.expireDate = this.expireDate1;
      }
    },
    expireTag(val, oldVal) {
      if (val == "续费") {
        this.selectValue = "1";
      } else if (val == "退费") {
        this.selectValue = "2";
      } else {
        this.selectValue = "请选择操作类型";
      }
    },
    bmTime(val, oldVal) {//编辑页面传值
    console.log(val)
      if (val) {
        this.bmTime = this.bmTime;

      }
    },
  },
  methods: {
    chgHandle() {
      if (this.len > 0) {
        this.modalShow = true;
      } else {
        alert("请先选择学生");
        return;
      }
    },
    modalConfirm() {
      // if (this.expireDate == "") {
      //   this.expireDate = "2121-01-01";
      // }

      this.$emit(
        "chgExpire",
        formatDateString(this.expireDate),
        this.selectValue,
        this.signupDate,
        this.bmTime
      );
      this.clear();
      this.modalShow = false;
    },
    modalCancel() {
      this.clear();
      this.modalShow = false;
    },
    clear() {
      this.expireDate = "";
      this.selectValue = "";
    }
  },
};
</script>

<style lang="less">
.el-input__inner {
  border: 1px solid #dcdee2;
}
</style>



// WEBPACK FOOTER //
// stuChgExpire.vue?e3a7c9ba